import "./Home.css";
import { useEffect, useState } from "react";

import slide1 from "../assets/neck.webp";
import slide2 from "../assets/neck2.webp";

const slides = [
  {
    title: "CASH FOR GOLD",
    text: "Convert your old gold into instant cash with best price and full transparency.",
    img: slide1
  },
  {
    title: "BEST GOLD PRICE",
    text: "We provide highest market value with accurate purity testing.",
    img: slide2
  }
];

export default function Home() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(slider);
  }, []);

  return (
    <section id="home" className="hero">

      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.img})` }}
        >
          <div className="overlay"></div>
          <div className="gradient"></div>

          <div className="content">
            <h1>
              CASH FOR <span>GOLD</span>
            </h1>

            <p>{slide.text}</p>

            <div className="buttons">
              <a href="#contact" className="btn primary">Call Us</a>
              <a href="#about" className="btn secondary">About Us</a>
            </div>
          </div>
        </div>
      ))}

    </section>
  );
}